import { render } from "./formInsertEstudo.vue?vue&type=template&id=70a7bbfc"
import script from "./formInsertEstudo.vue?vue&type=script&lang=js"
export * from "./formInsertEstudo.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ProjetosCodes\\Ideias\\admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__